<template>
	<!-- 巡检新增任务 -->
	<div>
		
		<div class="new-insp-task-info app-region blank-t-v blank-l-h blank-r-h">
		
			<a-row type="flex" class=" font-bold bb">
				<a-col>
					<p class="blank-l-h">任务信息</p>
				</a-col>
			</a-row>
		
			<a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal blank-t-v blank-b-v">
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>所属项目</p>
						</a-col>
						<a-col>
							<a-select class="app-block" placeholder="请选择设备所属项目" v-model="table.community_id">
								<a-select-option :value="item.id" v-for="item in communityOptions" :key="item.id">
									{{item.name}}
								</a-select-option>
							</a-select>
		
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>设备类别</p>
						</a-col>
						<a-col>
							<a-select class="app-block" placeholder="请选择设备类别" v-model="table.device_type_id">
								<a-select-option :value="value.id" v-for="value in deviceOptions" :key="value.id">
									{{value.name}}
								</a-select-option>
							</a-select>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>任务名称</p>
						</a-col>
						<a-col>
							<a-input placeholder="请输入任务名称" v-model="table.task_name"></a-input>
						</a-col>
					</a-row>
				</a-col>
		
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>管理岗位</p>
						</a-col>
						<a-col>
							<div class="new-input" placeholder="请选择管理岗位"  @click="showServerModal">
								<a-tag v-for="(value,index) in manageArr" :key="index" closable @click='delStaff(index)'> {{value.name}} </a-tag>
							</div>
								<a-modal :title="modalserver.title" v-model="modalserver.show" @ok="confirmServerModal" destroy-on-close width="60%" centered>
								  <tree-select v-model="modalserver.staff" :data="treeServer.data" :params="treeServer.params" multiple @click='delStaff(index)'></tree-select>
								</a-modal>
		
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>执行岗位</p>
						</a-col>
						<a-col>
							<div class="new-input" placeholder="请选择执行岗位"  @click="showServerTwoModal">
								<a-tag v-for="(value,index) in handleArr" :key="index" closable @click='delTwoStaff()'> {{value.name}} </a-tag>
							</div>
							<a-modal :title="modalservertwo.title" v-model="modalservertwo.show" @ok="confirmServerTwoModal" destroy-on-close width="60%" centered>
							  <tree-select v-model="modalservertwo.staff" :data="treeServerTwo.data" :params="treeServerTwo.params" multiple @click='delTwoStaff()'></tree-select>
							</a-modal>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>任务日期</p>
						</a-col>
						<a-col>
							<a-range-picker v-model="table.date" :default-value="[moment(table.date[0]), moment(table.date[1])]"
								valueFormat="YYYY-MM-DD" class="app-block"></a-range-picker>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>巡检周期</p>
						</a-col>
						<a-col>
							<a-select class="app-block" placeholder="请选择巡检周期" v-model="table.cycle_type">
								<a-select-option :value="1">{{checkCycle(1)}}</a-select-option>
								<a-select-option :value="2">{{checkCycle(2)}}</a-select-option>
								<a-select-option :value="3">{{checkCycle(3)}}</a-select-option>
								<a-select-option :value="4">{{checkCycle(4)}}</a-select-option>
							</a-select>
						</a-col>
					</a-row>
				</a-col>
		
				<template v-if="table.cycle_type === 1">
					<a-col :span="24" :xl="8">
						<a-row :gutter="[8, 8]">
							<a-col>
								<p>巡检间隔天数</p>
							</a-col>
							<a-col>
								<a-input-number v-model="table.day_data" placeholder="请输入巡检间隔天数" style="width: 100%">
								</a-input-number>
							</a-col>
						</a-row>
					</a-col>
				</template>
		
				<template v-if="table.cycle_type === 2">
					<a-col :span="24" :xl="8">
						<a-row :gutter="[8, 8]">
							<a-col>
								<p>任务生成日期</p>
							</a-col>
							<a-col>
								<div class="new-input" placeholder="请选择任务生成日期" @click="showWeekModal">
									<a-tag closable @close="() => delWeek(weekitem)" v-for="weekitem in this.table.week_data"
										:key="weekitem">
										{{ taglist[weekitem-1].text }}
									</a-tag>
								</div>
							</a-col>
						</a-row>
					</a-col>
				</template>
		
				<div>
					<a-modal v-model="visibleWeek" title="任务生成日期" centered ok-text="确认" cancel-text="取消" @ok="hideModal">
						<p>选择日期（周）</p>
						<template v-for="item in taglist">
							<a-checkable-tag :key="item.id" :checked="selectedTags.indexOf(item.id) > -1"
								@change="checked => handleChange(item.id, checked)" class="weektag">
								{{ item.text }}
							</a-checkable-tag>
						</template>
					</a-modal>
				</div>
		
				<template v-if="table.cycle_type === 3">
					<a-col :span="24" :xl="8">
						<a-row :gutter="[8, 8]">
							<a-col>
								<p>任务生成日期</p>
							</a-col>
							<a-col>
								<div class="new-input" placeholder="请选择任务生成日期" @click="showMothModal">
									<a-tag closable @close="() => delMoth(mothitem)" v-for="mothitem in table.month_data"
										:key="mothitem"> {{ mothitem }} </a-tag>
								</div>
							</a-col>
						</a-row>
					</a-col>
				</template>
		
				<div>
					<a-modal v-model="visibleMoth" title="任务生成日期" centered ok-text="确认" cancel-text="取消" @ok="hideMothModal">
						<p>选择日期（月）</p>
						<template v-for="mday in 31">
							<a-checkable-tag :key="mday" :checked="seleMonthTags.indexOf(mday) > -1"
								@change="checked => handleMothChange(mday, checked)" class="weektag">
								{{ mday }}
							</a-checkable-tag>
						</template>
					</a-modal>
				</div>
		
		
				<template v-if="table.cycle_type === 4">
					<a-col :span="24" :xl="8">
						<a-row :gutter="[8, 8]">
							<a-col>
								<p>任务生成日期</p>
							</a-col>
							<a-col>
								<div class="new-input" placeholder="请选择任务生成日期" @click="showYearModal">
									<a-tag closable @close="() => delYear(yearitem)"
										v-for="(yearitem,yyear) in this.table.year_data" :key="yearitem"> {{ yearitem }}
									</a-tag>
								</div>
							</a-col>
						</a-row>
					</a-col>
				</template>
		
				<div>
					<a-modal v-model="visibleYear" title="任务生成日期" centered ok-text="确认" cancel-text="取消" @ok="hideYearModal">
						<p>选择日期（年）</p>
						<div>
							<a-tabs default-active-key="1" :tabBarGutter="-18">
								<a-tab-pane v-for="yyear in 12" :key="yyear" :tab="`${yyear}月`">
									<template v-for="ymoth in monthArray[yyear - 1]">
										<a-checkable-tag v-if="yyear==1" :key="ymoth"
											:checked="seleYearTags1.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
										<a-checkable-tag v-if="yyear==2" :key="ymoth"
											:checked="seleYearTags2.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
										<a-checkable-tag v-if="yyear==3" :key="ymoth"
											:checked="seleYearTags3.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
										<a-checkable-tag v-if="yyear==4" :key="ymoth"
											:checked="seleYearTags4.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
										<a-checkable-tag v-if="yyear==5" :key="ymoth"
											:checked="seleYearTags5.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
										<a-checkable-tag v-if="yyear==6" :key="ymoth"
											:checked="seleYearTags6.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
										<a-checkable-tag v-if="yyear==7" :key="ymoth"
											:checked="seleYearTags7.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
										<a-checkable-tag v-if="yyear==8" :key="ymoth"
											:checked="seleYearTags8.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
										<a-checkable-tag v-if="yyear==9" :key="ymoth"
											:checked="seleYearTags9.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
										<a-checkable-tag v-if="yyear==10" :key="ymoth"
											:checked="seleYearTags10.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
										<a-checkable-tag v-if="yyear==11" :key="ymoth"
											:checked="seleYearTags11.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
										<a-checkable-tag v-if="yyear==12" :key="ymoth"
											:checked="seleYearTags12.indexOf(ymoth) > -1"
											@change="checked => handleYearChange(yyear,ymoth,checked)" class="weektag">
											{{ ymoth }}
										</a-checkable-tag>
									</template>
								</a-tab-pane>
							</a-tabs>
						</div>
					</a-modal>
				</div>
		
		
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>每日任务开始时间</p>
						</a-col>
						<a-col>
							<div class="new-input" @click="showModal()">
								<a-tag closable @close="() => delTaskTime(time)" v-for="time in table.task_start_time"
									:key="time"> {{time}} </a-tag>
							</div>
		
						</a-col>
					</a-row>
				</a-col>
				<a-modal :visible="visibleTimeModal" title="任务开始时间" ok-text="确认" cancel-text="取消" @ok="handleOk" centered>
					<p class="blank-b-v ">每日任务开始时间</p>
					<a-row>
						<a-col>
							<a-time-picker format="HH:mm" @change="onChange" />
							<a-space class="blank-l-h">
								<a-button @click="handleTimeConfirm" type="primary">添加</a-button>
							</a-space>
							<div class="blank-t-v  blank-b-v ">选择时间</div>
							<template>
								<a-tag closable @close="() => delTaskTime(time)" v-for="time in table.task_start_time"
									:key="time">{{time}}</a-tag>
							</template>
						</a-col>
					</a-row>
				</a-modal>
			</a-row>
		</div>
	
		
		<!-- 设备信息 -->
		<div class="new-insp-task-info app-region blank-t-v blank-l-h blank-r-h">
			<a-row type="flex" class="font-bold bb">
				<a-col>
					<p class="blank-l-h">设备信息</p>
				</a-col>
			</a-row>
		
			<a-row class="mg-normal" type="flex" justify="space-between">
				<a-col>
					<a-space>
						<a-button type="primary" @click="showDeviceModal">添加设备</a-button>
					</a-space>
					<a-space class="blank-l-h">
						<a-button @click="removeAll(table.data,id)">全部移除</a-button>
					</a-space>
				</a-col>
		
				<a-modal :title="modal.title" v-model="modal.show" destroy-on-close width="60%" centered @ok="confirmModal">
					<tree-select v-model="modal.device" :data="tree.data" :params="tree.params" multiple></tree-select>
				</a-modal>
		
				<a-col :span="8">
					<a-input-search v-model="inspName" placeholder="请输入设备名称或设备编号" @search="searchInspTable" />
				</a-col>
			</a-row>
		
			<a-table v-model="table.device_ids" class="mg-normal" :loading="table.loading" :columns="table.columns"
				:data-source="table.data" rowKey="id" :pagination="table.page">
				<template slot="action" slot-scope="text, data">
					<a-space>
						<a-button type="link" @click="removeOne(data,id)">移除</a-button>
					</a-space>
				</template>
			</a-table>
		</div>
		
		<footer class="app-footer blank-t-v blank-b-v ">
			<a-row type="flex" justify="end">
				<a-col>
					<a-space>
						<a-button @click="cancel">取消</a-button>
						<a-button type="primary" @click="submit">提交</a-button>
					</a-space>
				</a-col>
			</a-row>
		</footer>
		<div class="bottombox"></div>
		

	</div>


</template>

<script>
	import {
		checkCycle,
		deviceTypes
	} from '@/io/dict.js';
	import CommunityService from '@/io/community.js';
	import DeviceType from '@/io/device_type.js';
	import Equipment from "@/io/equipment.js";
	import OrganizationService from '@/io/organization.js';
	import Inspection from '@/io/inspection.js'

	import moment from 'moment';




	export default {
		name: 'NewInspTaskInfo',
		data() {
			let self = this;
			return {

				handleArr:[],
				manageArr:[],
				
				id: this.$route.params.id,
				inspName:'',
				inspArr:'',
				
				communityOptions: [],
				deviceOptions: [],
				serverOptions: [],

				treeServer: {
					data: [],
					params: {
						children: 'children',
						title: 'name',
						key: 'backupId'
					}
				},
				modalserver: {
					title: '选择人员',
					show: false,
					staff: []
				},
				treeServerTwo: {
					data: [],
					params: {
						children: 'children',
						title: 'name',
						key: 'backupId'
					}
				},
				modalservertwo: {
					title: '选择人员',
					show: false,
					staff: []
				},


				tree: {
					data: [],
					params: {
						children: 'children',
						title: 'name',
						key: 'id'
					}
				},
				modal: {
					title: '选择设备',
					show: false,
					device: []
				},



				deviceTypes,
				// visible: false,
				//选择时间弹框
				tags: null,

				checkCycle,
				deviceTypes,

				taglist: [{
						id: '1',
						text: '周一'
					},
					{
						id: '2',
						text: '周二'
					},
					{
						id: '3',
						text: '周三'
					},
					{
						id: '4',
						text: '周四'
					},
					{
						id: '5',
						text: '周五'
					},
					{
						id: '6',
						text: '周六'
					},
					{
						id: '7',
						text: '周日'
					},
				],
				selectedTags: [], //这是周期数组

				//这是月数组
				seleMonthTags: [],

				//这是年数组
				seleYearTags1: [],
				seleYearTags2: [],
				seleYearTags3: [],
				seleYearTags4: [],
				seleYearTags5: [],
				seleYearTags6: [],
				seleYearTags7: [],
				seleYearTags8: [],
				seleYearTags9: [],
				seleYearTags10: [],
				seleYearTags11: [],
				seleYearTags12: [],

				// 这是定义的月份包含的时间天数
				monthArray: [],


				visibleWeek: false,
				visibleMoth: false,
				visibleYear: false,
				visibleDate: false,
				visibleTimeModal: false,

				task_start_time_default: null,

				table: {
					loading: false,

					//这里是绑定的name
					community_id: null,
					device_type_id: null,
					task_name: '',
					date: [],
					cycle_type: 1,
					day_data: null,
					week_data: [],
					month_data: [],
					year_data: [],
					task_start_time: [],
					manage_property:[],
					handle_property:[],
					device_ids: [],
					task_start_date: null,
					task_end_date: null,

					page: {
						total: 0,
						current: 1,
						pageSize: 10,
						showQuickJumper: true,
						showSizeChanger: true,
						showTotal() {
							return `共${self.table.page.total}条`;
						}
					},
					data: [],
					search: {
						name: null,
						device_model: null,
					},
					searchName: '',
					columns: [{
							title: '设备名称',
							dataIndex: 'name'
						},
						{
							title: '设备编号',
							dataIndex: 'device_model'
						},
						{
							title: '空间位置',
							dataIndex: 'position'
						},

						{
							title: '操作',
							scopedSlots: {
								customRender: 'action'
							},
						}
					],

				},


			}
		},

		mounted() {
			// 获取当前日期
			var date = new Date()
			// 遍历月份
			for (let i = 1; i <= 12; i++) {
				// 调用方法，将年和月进行传值
				this.getDaysInoneMonth(date.getFullYear(), i)
			}
			// console.log('monthArray', this.monthArray)

			// if (this.id) {
			// 	this.initPage()
			// }
			this.initCommunity()
			this.initDevice()
			// this.initServer()
			this.initTreeServerData()
			this.initTreeServerTwoData()
			// this.initTreeData()
			
		},
		activated() {
			this.initData()
		},

		methods: {

			

			//时间弹框
			moment,

			// 周组件
			showWeekModal() {
				this.visibleWeek = true;
			},
			hideModal(e) {
				this.visibleWeek = false;
				this.table.week_data = this.selectedTags
				console.log('WWW', this.table.week_data)
			},
			// 删除页面上的tag
			delWeek(weekitem) {
				const tagweek = this.table.week_data.filter(tweek => tweek !== weekitem);
				this.table.week_data = tagweek
				console.log('this.table.week_data', this.table.week_data)
			},
			handleChange(item, checked) {
				const {
					selectedTags
				} = this;
				const nextSelectedTags = checked ? [...selectedTags, item] : selectedTags.filter(t => t.id !== item.id);
				console.log('checked111111111',checked.id)
				this.selectedTags = nextSelectedTags;
			},

			// 月组件
			showMothModal() {
				this.visibleMoth = true;
			},
			hideMothModal(e) {
				this.visibleMoth = false;
				this.table.month_data = this.seleMonthTags
				console.log('MMM', this.table.month_data)
			},
			// 删除页面上的tag
			delMoth(mothitem) {
				const tagmoth = this.table.month_data.filter(tmoth => tmoth !== mothitem);
				this.table.month_data = tagmoth
				console.log('this.table.month_data', this.table.month_data)
			},
			handleMothChange(mothitem, checked) {
				const {
					seleMonthTags
				} = this;
				const nextMothSelectedTags = checked ? [...seleMonthTags, mothitem] : seleMonthTags.filter(t => t.id !==
					mothitem.id);
				this.seleMonthTags = nextMothSelectedTags;
			},

			// 获取某年某月下的月对应的天数
			getDaysInoneMonth(year, month) {
				month = parseInt(month, 10);
				var day = new Date(year, month, 0);
				// 给定义的数组添加方法
				this.monthArray.push(day.getDate())
			},


			// 年组件
			showYearModal() {
				this.visibleYear = true;
			},
			delYear(yearitem) {
				const tagyear = this.table.year_data.filter(tagyear => tagyear !== yearitem);
				this.table.year_data = tagyear
			},
			hideYearModal(e) {
				this.visibleYear = false;

				for (var i1 in this.seleYearTags1) {
					if (this.seleYearTags1.length > 0) {
						if (this.seleYearTags1[i1] < 10) {
							this.table.year_data.push('01' + '-' + 0 + this.seleYearTags1[i1])
						} else {
							this.table.year_data.push('01' + '-' + this.seleYearTags1[i1])
						}
					} else {
						this.seleYearTags1 = ''
					}
				}
				for (var i2 in this.seleYearTags2) {
					if (this.seleYearTags2.length > 0) {
						if (this.seleYearTags2[i2] < 10) {
							this.table.year_data.push('02' + '-' + 0 + this.seleYearTags2[i2])
						} else {
							this.table.year_data.push('02' + '-' + this.seleYearTags2[i2])
						}
					} else {
						this.seleYearTags2 = ''
					}
				}
				for (var i3 in this.seleYearTags3) {
					if (this.seleYearTags3.length > 0) {
						if (this.seleYearTags3[i3] < 10) {
							this.table.year_data.push('03' + '-' + 0 + this.seleYearTags3[i3])
						} else {
							this.table.year_data.push('03' + '-' + this.seleYearTags3[i3])
						}
					} else {
						this.seleYearTags3 = ''
					}
				}
				for (var i4 in this.seleYearTags4) {
					if (this.seleYearTags4.length > 0) {
						if (this.seleYearTags4[i4] < 10) {
							this.table.year_data.push('04' + '-' + 0 + this.seleYearTags4[i4])
						} else {
							this.table.year_data.push('04' + '-' + this.seleYearTags4[i4])
						}
					} else {
						this.seleYearTags4 = ''
					}
				}
				for (var i5 in this.seleYearTags5) {
					if (this.seleYearTags5.length > 0) {
						if (this.seleYearTags5[i5] < 10) {
							this.table.year_data.push('05' + '-' + 0 + this.seleYearTags1[i5])
						} else {
							this.table.year_data.push('05' + '-' + this.seleYearTags1[i5])
						}
					} else {
						this.seleYearTags5 = ''
					}
				}
				for (var i6 in this.seleYearTags6) {
					if (this.seleYearTags6.length > 0) {
						if (this.seleYearTags6[i6] < 10) {
							this.table.year_data.push('06' + '-' + 0 + this.seleYearTags6[i6])
						} else {
							this.table.year_data.push('06' + '-' + this.seleYearTags6[i6])
						}
					} else {
						this.seleYearTags6 = ''
					}
				}
				for (var i7 in this.seleYearTags7) {
					if (this.seleYearTags7.length > 0) {
						if (this.seleYearTags7[i7] < 10) {
							this.table.year_data.push('07' + '-' + 0 + this.seleYearTags7[i7])
						} else {
							this.table.year_data.push('07' + '-' + this.seleYearTags7[i7])
						}
					} else {
						this.seleYearTags7 = ''
					}
				}
				for (var i8 in this.seleYearTags8) {
					if (this.seleYearTags8.length > 0) {
						if (this.seleYearTags8[i8] < 10) {
							this.table.year_data.push('08' + '-' + 0 + this.seleYearTags8[i8])
						} else {
							this.table.year_data.push('08' + '-' + this.seleYearTags8[i8])
						}
					} else {
						this.seleYearTags8 = ''
					}
				}
				for (var i9 in this.seleYearTags9) {
					if (this.seleYearTags9.length > 0) {
						if (this.seleYearTags9[i9] < 10) {
							this.table.year_data.push('09' + '-' + 0 + this.seleYearTags9[i9])
						} else {
							this.table.year_data.push('09' + '-' + this.seleYearTags9[i9])
						}
					} else {
						this.seleYearTags9 = ''
					}
				}
				for (var i10 in this.seleYearTags10) {
					if (this.seleYearTags10.length > 0) {
						if (this.seleYearTags10[i10] < 10) {
							this.table.year_data.push('10' + '-' + 0 + this.seleYearTags10[i10])
						} else {
							this.table.year_data.push('10' + '-' + this.seleYearTags10[i10])
						}
					} else {
						this.seleYearTags10 = ''
					}
				}
				for (var i11 in this.seleYearTags11) {
					if (this.seleYearTags11.length > 0) {
						if (this.seleYearTags11[i11] < 10) {
							this.table.year_data.push('11' + '-' + 0 + this.seleYearTags11[i11])
						} else {
							this.table.year_data.push('11' + '-' + this.seleYearTags11[i11])
						}
					} else {
						this.seleYearTags11 = ''
					}
				}
				for (var i12 in this.seleYearTags12) {
					if (this.seleYearTags12.length > 0) {
						if (this.seleYearTags12[i12] < 10) {
							this.table.year_data.push('12' + '-' + 0 + this.seleYearTags12[i12])
						} else {
							this.table.year_data.push('12' + '-' + this.seleYearTags12[i12])
						}
						// this.table.year_data.push('12月'+'-'+this.seleYearTags12[i12] +'日')
					} else {
						this.seleYearTags12 = ''
					}
				}

				console.log('MMM', this.table.year_data)

			},
			handleYearChange(yyear, yearitem, checked) {
				console.log('月月月', yyear)
				const {
					seleYearTags1,
					seleYearTags2,
					seleYearTags3,
					seleYearTags4,
					seleYearTags5,
					seleYearTags6,
					seleYearTags7,
					seleYearTags8,
					seleYearTags9,
					seleYearTags10,
					seleYearTags11,
					seleYearTags12
				} = this;
				if (yyear == 1) {
					const nextTearSelectedTags = checked ? [...seleYearTags1, yearitem] : seleYearTags1.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags1 = nextTearSelectedTags;
				}
				if (yyear == 2) {
					const nextTearSelectedTags = checked ? [...seleYearTags2, yearitem] : seleYearTags2.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags2 = nextTearSelectedTags;
				}
				if (yyear == 3) {
					const nextTearSelectedTags = checked ? [...seleYearTags3, yearitem] : seleYearTags3.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags3 = nextTearSelectedTags;
				}
				if (yyear == 4) {
					const nextTearSelectedTags = checked ? [...seleYearTags4, yearitem] : seleYearTags4.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags4 = nextTearSelectedTags;
				}
				if (yyear == 5) {
					const nextTearSelectedTags = checked ? [...seleYearTags5, yearitem] : seleYearTags5.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags5 = nextTearSelectedTags;
				}
				if (yyear == 6) {
					const nextTearSelectedTags = checked ? [...seleYearTags6, yearitem] : seleYearTags6.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags6 = nextTearSelectedTags;
				}
				if (yyear == 7) {
					const nextTearSelectedTags = checked ? [...seleYearTags7, yearitem] : seleYearTags7.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags7 = nextTearSelectedTags;
				}
				if (yyear == 8) {
					const nextTearSelectedTags = checked ? [...seleYearTags8, yearitem] : seleYearTags8.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags8 = nextTearSelectedTags;
				}
				if (yyear == 9) {
					const nextTearSelectedTags = checked ? [...seleYearTags9, yearitem] : seleYearTags9.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags9 = nextTearSelectedTags;
				}
				if (yyear == 10) {
					const nextTearSelectedTags = checked ? [...seleYearTags10, yearitem] : seleYearTags10.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags10 = nextTearSelectedTags;
				}
				if (yyear == 11) {
					const nextTearSelectedTags = checked ? [...seleYearTags11, yearitem] : seleYearTags11.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags1 = nextTearSelectedTags;
				}
				if (yyear == 12) {
					const nextTearSelectedTags = checked ? [...seleYearTags12, yearitem] : seleYearTags12.filter(t => t
						.id !== yearitem.id);
					this.seleYearTags12 = nextTearSelectedTags;
				}
			},
			// 岗位弹窗
			showServerModal() {
				this.modalserver.show = true;
				this.modalserver.staff = this.manageArr;
				console.log('this.manageArr',this.manageArr)
				 
			},
			// 确定按钮
			confirmServerModal() {
				this.modalserver.show = false;
				// this.initTreeServerData()
				this.manageArr = this.modalserver.staff;
				
			},
			// 需要删除
			delStaff(index) {
				this.modalserver.staff.splice(index, 1);
			},
			initTreeServerData() {
				return OrganizationService.companyStaffList().then(res => {
				  this.$depthSearchTree(node => {
				    if (node.type === 1) {
				      node.disabled = true;
				      node.backupId = `d-${node.id}`;
				    } else {
				      node.backupId = `s-${node.id}`;
				    }
				  }, res);
					this.treeServer.data = res;
					
					if (this.id) {
						this.initPage()
					}
				}).catch(err => {});
			},
			// 第二个
			showServerTwoModal(){
				this.modalservertwo.show = true;
				this.modalservertwo.staff = this.handleArr;
				
			},
			confirmServerTwoModal() {
				this.modalservertwo.show = false;
				this.handleArr = this.modalservertwo.staff;
			},
			delTwoStaff(index) {
				this.modalservertwo.staff.splice(index, 1);
			},
			initTreeServerTwoData() {
				return OrganizationService.companyStaffList().then(res => {
				  this.$depthSearchTree(node => {
				    if (node.type === 1) {
				      node.disabled = true;
				      node.backupId = `d-${node.id}`;
				    } else {
				      node.backupId = `s-${node.id}`;
				    }
				  }, res);
					this.treeServerTwo.data = res;
					
					
				}).catch(err => {});
				
			},

			// 添加设备弹框
			showDeviceModal() {
				if (this.table.device_type_id == this.table.device_type_id ) {
					this.initTreeData()
					this.modal.show = true;
				} else {
					this.$message.error('请选择设备类别');
				}
			},
			// 弹框内的设备数据
			initTreeData() {
				return Equipment.list({
					"device_type_id": this.table.device_type_id
				}).then(res => {
					this.tree.data = res;
				}).catch(err => {});
			},

			// 将设备弹窗内的数据显示在表格内,数据有多少条也显示
			confirmModal() {
					this.table.data = this.modal.device
					this.table.page.total = this.table.data.length
					this.modal.show = false;
					this.inspArr = this.table.data
			},
			// 全部移除
			removeAll(id) {
				this.id = this.table.data.id
				this.table.data.splice(id)
				this.table.page.total = this.table.data.length
				this.inspArr = this.table.data
			},
			// 删除表格内一行数据
			removeOne(id) {
				this.table.data.splice(id, 1)
				this.table.page.total = this.table.data.length
				this.inspArr = this.table.data
			},
			searchInspTable() {
				if(this.inspName){
					var inspMany = []
					for(let i = 0;i<this.table.data.length;i++){
						if(this.table.data[i].name.indexOf(this.inspName)>-1){
							inspMany.push(this.table.data[i])
						}
					}
					this.table.data = inspMany
				}else{
					this.table.data = this.inspArr
				}
			},

			// 显示任务开始时间弹框
			showModal() {
				this.visibleTimeModal = true;
			},
			// 关闭任务开始时间弹框
			handleOk(e) {
				this.visibleTimeModal = false;
			},
			// 获取时间组件内的时间
			onChange(time) {
				const times = this.moment(time).format("HH:mm");
				this.task_start_time_default = times;
			},

			// 添加时间操作
			handleTimeConfirm() {
				if (this.table.task_start_time.indexOf(this.task_start_time_default) == -1) {
					this.table.task_start_time.push(this.task_start_time_default)
				}
			},
			// 删除任务时间数组
			delTaskTime(time) {
				const tags = this.table.task_start_time.filter(tag => tag !== time);
				this.table.task_start_time = tags;
			},
			// 分页
			handlePageChange(page) {
				this.table.page.current = page.current;
				this.table.page.pageSize = page.pageSize;
				this.initData();
			},
			// 社区数据
			initCommunity() {
				return CommunityService.listPage().then(res => {
					this.communityOptions = res;
				}).catch(err => {});
			},
			// 设备类型数据
			initDevice() {
				return DeviceType.listPage().then(res => {
					this.deviceOptions = res;
				}).catch(err => {});
			},
			// 岗位
			// initServer() {
			// 	return OrganizationService.staffListPage().then(res => {
			// 		this.serverOptions = res;
			// 	}).catch(err => {})
			// },
			// 新增页面
			initData() {
				// 开始时间和结束时间
				this.table.task_start_date = this.table.date[0]
				this.table.task_end_date = this.table.date[1]
				this.table.device_ids = []
				this.table.data.forEach(item => {
					this.table.device_ids = [...this.table.device_ids, item.id]
				})
				
				this.table.loading = true;
				Inspection.listPage(
					this.table.community_id,
					this.table.device_type_id,
					this.table.task_name,
					this.table.task_start_date,
					this.table.task_end_date,
					this.table.cycle_type,
					this.table.day_data,
					this.table.week_data,
					this.table.month_data,
					this.table.year_data,
					this.table.task_start_time,
					this.table.manage_property,
					this.table.handle_property,
					this.table.device_ids,
					this.table.page.current,
					this.table.page.pageSize
				).then(res => {
					console.log('res', res)
					this.table.data = res.data.map(val => {
						return val;
					});
					// this.table.page.total = res.meta.pagination.total;
				}).catch(err => {}).finally(() => {
					this.table.loading = false;
				});
			},
			// 编辑页的详细信息
			initPage() {
					
				Inspection.info(this.id).then(res => {
					this.table.date[0] = res.task_start_date
					this.table.date[1] = res.task_end_date
					this.table.task_start_date = res.task_start_date
					this.table.task_end_date = res.task_end_date
					this.table.community_id = res.community_id
					this.table.device_type_id = res.device_type_id
					this.table.task_name = res.task_name
					this.table.cycle_type = res.cycle_type
					if(this.table.cycle_type ==1){
						this.table.day_data = res.time_data[0] 
					}
					if(this.table.cycle_type ==2){
						this.table.week_data = res.time_data
					}
					if(this.table.cycle_type ==3){
						this.table.month_data= res.time_data
					}
					if(this.table.cycle_type ==4){
						this.table.year_data= res.time_data
					}
					this.table.task_start_time = res.task_start_time
					
					this.table.data = res.device
					this.inspArr = this.table.data
					
					this.table.page.total = res.device.length
					
					
					let manageProperty = res.manage_property
					let handleProperty = res.handle_property
					
					this.treeServer.data.forEach(item=>{
						
						if(item.children.length){
							
							item.children.forEach(child=>{
								manageProperty.forEach(manage=>{
									if(manage.property_id == child.id){
										this.manageArr = [...this.manageArr,child]
									}
								})
								handleProperty.forEach(handle=>{
									if(handle.property_id == child.id){
										this.handleArr = [...this.handleArr,child]
									}
								})
							})
						}
					})
					
				
				}).catch(err => {})
			},
			// 提交页面
			submit() {
				this.table.device_ids = []
				this.table.data.forEach(item => {
					this.table.device_ids = [...this.table.device_ids, item.id]
				})
				this.table.task_start_date = this.table.date[0]
				this.table.task_end_date = this.table.date[1]
				this.table.day_data = Number(this.table.day_data)
				// 岗位1
				var manageIdArr = []
				manageIdArr = this.manageArr.map(x=>x.id)
				this.table.manage_property = manageIdArr 
				
				// 岗位2
				var handleIdArr = []
				handleIdArr = this.handleArr.map(x=>x.id)
				this.table.handle_property = handleIdArr 
				
				if (this.id) {
					Inspection.edit(
						this.id,
						this.table.community_id,
						this.table.device_type_id,
						this.table.task_name,
						this.table.task_start_date,
						this.table.task_end_date,
						this.table.cycle_type,
						this.table.day_data,
						this.table.week_data,
						this.table.month_data,
						this.table.year_data,
						this.table.task_start_time,
						this.table.manage_property,
						this.table.handle_property,
						this.table.device_ids,

					).then((res) => {
						this.$afterFormSubmit('编辑成功', () => {
							this.cancel();
						});
					}).catch((err) => {})
				} else {
					Inspection.add(
						this.table.community_id,
						this.table.device_type_id,
						this.table.task_name,
						this.table.task_start_date,
						this.table.task_end_date,
						this.table.cycle_type,
						this.table.day_data,
						this.table.week_data,
						this.table.month_data,
						this.table.year_data,
						this.table.task_start_time,
						this.table.manage_property,
						this.table.handle_property,
						this.table.device_ids,
					).then((res) => {
						this.$afterFormSubmit('编辑成功', () => {
							this.cancel();
						});
					}).catch((err) => {})
				}
			},
			cancel() {
				this.$router.push({
					name: 'InspectionTask'
				})
			},
		},
	}
</script>

<style lang="less" scoped>
	/deep/ .ant-tag-checkable-checked {
		color: black;
		background-color: #108ee9;
	}
</style>
